/* eslint-disable no-console */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useRef } from 'react';
import './englishAgent.css';

function EnglishAgent() {
  const formRef = useRef();
  const [submitted, setSubmitted] = React.useState(false);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    let timeout;

    if (submitted || error) {
      timeout = setTimeout(() => {
        setSubmitted(false);
        setError(false);
      }, 5000);
    }

    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [submitted, error]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);

    try {
      await fetch(
        'https://docs.google.com/forms/d/e/1FAIpQLSfX1scttMNeEiWFfj3Fz66L_OpKmgWLgtCZKUN_h1IDpIWnGA/formResponse',
        {
          method: 'POST',
          mode: 'no-cors',
          body: formData,
        },
      );

      setSubmitted(true);
      setError(false);
      formRef.current.reset(); // optional: reset the form after submit
    } catch (error) {
      console.error('Form submission error:', error);
      setError(true);
      setSubmitted(false);
    }
  };

  return (
    <div className="english-agent-container">
      <div className="container">
        <div className="form-container">
          <h1 className="form-title">Social Media Post Creator</h1>
          <div className="form-intro">
            <p>
              This agent is a
              <strong> DEMO </strong>
              product built for personal branding agencies that want to integrate smart tech features directly into their websites.
            </p>

            <p>
              After submitting the form, this assistant will generate a unique, customized social media post based on your input and send it straight to your email.
              <strong> Please enter the email address where you’d like to receive your post.</strong>
            </p>

            <p>
              <i>
                *Each agents logic, design, and contextual training data can be fully tailored to meet the specific requirements of your application.
                <br />
                <br />
                **As the admin, youre instantly notified of every user prompt, the AI-generated response, submitted contact information, and access to request history.
              </i>
            </p>

            <p>
              <strong>NOTE: </strong>
              If youd like to learn more on how to offer this experience to your own clients or website visitors, you can book a meeting with me here:
              <a className="calendly" href="https://calendly.com/me-giojuliao/30min" target="_blank" rel="noopener noreferrer"> Calendly.</a>
              <div>
                <br />
                {/* <a href="https://www.loom.com/share/YOUR-VIDEO-ID-HERE" target="_blank" rel="noopener noreferrer">Watch the quick explainer video.</a> */}
              </div>
            </p>
          </div>

          <form className="form" onSubmit={handleSubmit} ref={formRef}>
            {/* Email Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="email"
                  id="email"
                  name="entry.1022742670"
                  required
                  className="form-input"
                  placeholder="tim@apple.com"
                />
                <label htmlFor="email" className="select-label required">
                  Email
                </label>
              </div>
            </div>

            {/* Hidden Language Field - Set to English */}
            <input
              type="hidden"
              id="language"
              name="entry.1068312819"
              value="English"
            />

            {/* ICP Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="icp"
                  name="entry.1299469748"
                  required
                  className="form-input"
                  placeholder="Young entrepeneurs"
                />
                <label htmlFor="icp" className="select-label required">
                  ICP
                </label>
              </div>
            </div>

            {/* Industry Pain Point Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="painPoint"
                  name="entry.447725973"
                  required
                  className="form-input"
                  placeholder="Limited tracking expense education habit."
                />
                <label htmlFor="painPoint" className="select-label required">
                  Industry Pain Point
                </label>
              </div>
            </div>

            {/* Personal Experience Field (Long Text) */}
            <div className="form-group">
              <div className="input-container textarea-container">
                <textarea
                  id="experience"
                  name="entry.474915785"
                  required
                  className="form-textarea"
                  placeholder="Ex.: I have found out that more than 70% of my customers don't track their expenses properly."
                  rows="4"
                />
                <label htmlFor="experience" className="select-label required">
                  Personal Experience
                </label>
              </div>
            </div>

            {/* Topic Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="topic"
                  name="entry.334211356"
                  required
                  className="form-input"
                  placeholder="Innovation"
                />
                <label htmlFor="topic" className="select-label required">
                  Topic
                </label>
              </div>
            </div>

            {/* Type Field (Post as default, Article unavailable) */}
            <div className="form-group">
              <div className="select-container">
                <select
                  id="type"
                  name="entry.1001187496"
                  className="form-select"
                  defaultValue=""
                  required
                >
                  <option value="" disabled>Select an option</option>
                  <option value="Post">Post</option>
                  <option value="Article" disabled>Article</option>
                </select>
                <label htmlFor="type" className="select-label required">
                  Type
                </label>
              </div>
            </div>

            {/* Tone Field */}
            <div className="form-group">
              <div className="select-container">
                <select
                  id="tone"
                  name="entry.1084518434"
                  required
                  className="form-select"
                  defaultValue=""
                >
                  <option value="" disabled>Select a tone</option>
                  <option value="Professional">Professional</option>
                  <option value="Conversational">Conversational</option>
                  <option value="Enthusiastic">Enthusiastic</option>
                  <option value="Authoritative">Authoritative</option>
                  <option value="Reflective">Reflective</option>
                </select>
                <label htmlFor="tone" className="select-label required">
                  Tone
                </label>
              </div>
            </div>

            {/* Industry Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="industry"
                  name="entry.1455359113"
                  required
                  className="form-input"
                  placeholder="Finance"
                />
                <label htmlFor="industry" className="select-label required">
                  Industry
                </label>
              </div>
            </div>

            {/* Include Emojis Field */}
            <div className="form-group">
              <div className="select-container">
                <select
                  id="emojis"
                  name="entry.1711478775"
                  required
                  className="form-select"
                  defaultValue=""
                >
                  <option value="" disabled>Select an option</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                <label htmlFor="emojis" className="select-label required">
                  Include Emojis?
                </label>
              </div>
            </div>

            {/* Include Hashtags Field */}
            <div className="form-group">
              <div className="select-container">
                <select
                  id="hashtags"
                  name="entry.2055891147"
                  required
                  className="form-select"
                  defaultValue=""
                >
                  <option value="" disabled>Select an option</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                <label htmlFor="hashtags" className="select-label required">
                  Include relevant Hashtags?
                </label>
              </div>
            </div>

            {/* Submit Button */}
            <div className="required-note consent">
              <span className="required-symbol">*</span>
              <p>By submitting this form, you agree to be contacted via email with your personalized content and occasional updates related to this service.</p>
            </div>
            <div className="button-container">
              <button
                type="submit"
                className="submit-button"
              >
                Submit
              </button>
              <div className="submit-button-response">
                {submitted && (
                  <div className="form-success-message">
                    🎉 Thanks! Your response has been submitted.
                  </div>
                )}

                {error && (
                <div className="form-error-message">
                  ❌ Oops! Something went wrong. Please try again in a few seconds.
                </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EnglishAgent;
